import { Component, OnInit, Input } from "@angular/core";

interface IInfoBox {
  uuid: string;
  title: string;
  current_price: string | number;
  real_estate_type_id: string | number;
  auction_number: string | number;
  lot_number: string | number;
  currency_id: string | number;
  starting_price: string | number;
  warranty_price: string | number;
  last_bid: any;
  bid_price: string | number;
  bids_count: string | number;
  start_date: any;
  start_date_timestamp: string | number;
  end_date: any;
  end_date_timestamp: string | number;
  time_left: string | number;
  is_active: boolean;
  country_id: string | number;
  city_id: string | number;
  street: string;
  image: any;
  status: string;
  status_key: string;
}

@Component({
  selector: "app-auction-info-box",
  templateUrl: "./auction-info-box.component.html",
  styleUrls: ["./auction-info-box.component.scss"],
})
export class AuctionInfoBoxComponent implements OnInit {
  @Input() data: IInfoBox;

  constructor() {}

  ngOnInit() {}

  get priceType() {
    return this.data.status_key === "not_started"
      ? "საწყისი ფასი"
      : this.data.status_key === "active"
        ? "მიმდინარე ფასი"
        : "საბოლოო ფასი";
  }
}
